import { route } from '@/ziggy-shim';
import { api, apiConfig, CastValue } from './LaravelClient';

export default {
  async index() {
    return await api(route('api.v1.companies.index'), 'get');
  },

  async create(data: ApiRequests['api.v1.admin.companies.store']) {
    return await api(route('api.v1.admin.companies.store'), 'post', {
      data,
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.companies.update']) {
    return await api(route('api.v1.companies.update', id), 'patch', {
      data,
      casts: {
        acn: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        abn: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        office_address: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        contact_name: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        contact_phone: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        contact_email: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        general_notices_email: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  logo: {
    async store(id: Id, data: ApiRequests['api.v1.companies.logo.store'] | FormData) {
      return await api(route('api.v1.companies.logo.store', id), 'post', {
        data,
      });
    },

    async show(id: Id, projectId?: Id) {
      return await api(route('api.v1.companies.logo.show', [id, projectId]), 'get');
    },
  },

  async delete(id: Id) {
    return await api(route('api.v1.admin.companies.destroy', id), 'delete');
  },

  async adminIndex(page = 1) {
    return await apiConfig(route('api.v1.admin.companies.index'), 'get', {
      params: {
        page,
      },
    });
  },

  async adminShow(id: Id) {
    return await api(route('api.v1.admin.companies.show', id), 'get');
  },

  async adminUpdate(id: Id, data: ApiRequests['api.v1.admin.companies.update']) {
    return await api(route('api.v1.admin.companies.update', id), 'patch', {
      data,
    });
  },
};
